import herpShop from "../assets/projects/pro-shop/shop.jpg";
import shop_1 from "../assets/projects/pro-shop/img1.PNG";
import shop_2 from "../assets/projects/pro-shop/img2.PNG";
import shop_3 from "../assets/projects/pro-shop/img3.PNG";
import shop_4 from "../assets/projects/pro-shop/img10.PNG";
import shop_5 from "../assets/projects/pro-shop/img11.PNG";
import shop_6 from "../assets/projects/pro-shop/img12.PNG";
import shop_7 from "../assets/projects/pro-shop/img7.PNG";
import shop_8 from "../assets/projects/pro-shop/img8.PNG";
import shop_9 from "../assets/projects/pro-shop/img9.PNG";

import nextor from "../assets/projects/nextor/nextor.jpg";
import nextor_1 from "../assets/projects/nextor/1.PNG";
import nextor_2 from "../assets/projects/nextor/2.PNG";
import nextor_3 from "../assets/projects/nextor/3.PNG";
import nextor_4 from "../assets/projects/nextor/4.PNG";

import venu from "../assets/projects/venu/venue.jpg";
import venu_1 from "../assets/projects/venu/1.PNG";
import venu_2 from "../assets/projects/venu/2.PNG";
import venu_3 from "../assets/projects/venu/3.PNG";
import venu_4 from "../assets/projects/venu/4.PNG";
import venu_5 from "../assets/projects/venu/5.PNG";

import neatour from "../assets/projects/natuors/natour.jpg";
import neatour_1 from "../assets/projects/natuors/1.PNG";
import neatour_2 from "../assets/projects/natuors/2.PNG";
import neatour_3 from "../assets/projects/natuors/3.PNG";
import neatour_4 from "../assets/projects/natuors/4.PNG";
import neatour_5 from "../assets/projects/natuors/5.PNG";

import behero from "../assets/projects/quiz/quiz.jpg";
import behero_1 from "../assets/projects/quiz/img1.PNG";
import behero_2 from "../assets/projects/quiz/img2.PNG";
import behero_3 from "../assets/projects/quiz/img3.PNG";

import palAgency from "../assets/projects/agency/agency.jpg";
import palAgency_1 from "../assets/projects/agency/img1.PNG";
import palAgency_2 from "../assets/projects/agency/img2.PNG";
import palAgency_3 from "../assets/projects/agency/img3.PNG";
import palAgency_4 from "../assets/projects/agency/img4.PNG";
import palAgency_5 from "../assets/projects/agency/img5.PNG";

import ui from "../assets/projects/material-ui/material-ui.jpg";
import ui_1 from "../assets/projects/material-ui/1.PNG";
import ui_2 from "../assets/projects/material-ui/2.PNG";
import ui_3 from "../assets/projects/material-ui/3.PNG";
import ui_4 from "../assets/projects/material-ui/4.PNG";
import ui_5 from "../assets/projects/material-ui/5.PNG";

import limelite_1 from "../assets/projects/limelite/2.jpg";
import limelite_2 from "../assets/projects/limelite/4.jpg";
import limelite_3 from "../assets/projects/limelite/3.jpg";
import limelite_4 from "../assets/projects/limelite/5.jpg";
import limelite_5 from "../assets/projects/limelite/6.jpg";
import limelite_7 from "../assets/projects/limelite/7.jpg";
import limelite_8 from "../assets/projects/limelite/8.jpg";
import limelite_16 from "../assets/projects/limelite/16.jpg";

import limelite_12 from "../assets/projects/limelite/12.jpg";
import limelite_10 from "../assets/projects/limelite/10.jpg";
import limelite_9 from "../assets/projects/limelite/9.jpg";
import limelite_11 from "../assets/projects/limelite/11.jpg";

import limelite_15 from "../assets/projects/limelite/15.jpg";
import limelite_17 from "../assets/projects/limelite/17.jpg";
import limelite_18 from "../assets/projects/limelite/18.jpg";
import limelite_19 from "../assets/projects/limelite/19.jpg";
import limelite_23 from "../assets/projects/limelite/23.jpg";

import limelite_20 from "../assets/projects/limelite/20.jpg";
import limelite_21 from "../assets/projects/limelite/21.jpg";
import limelite_22 from "../assets/projects/limelite/22.jpg";

import logo from "../assets/projects/alesayi/logo.jpg";
import alesayi_1 from "../assets/projects/alesayi/1.jpg";
import alesayi_2 from "../assets/projects/alesayi/2.jpg";
import alesayi_4 from "../assets/projects/alesayi/4.jpg";
import alesayi_3 from "../assets/projects/alesayi/3.jpg";
import alesayi_5 from "../assets/projects/alesayi/5.jpg";
import alesayi_6 from "../assets/projects/alesayi/6.jpg";
import alesayi_7 from "../assets/projects/alesayi/7.jpg";

import abacus_1 from "../assets/projects/abacus/1.jpg";
import abacus_2 from "../assets/projects/abacus/2.jpg";
import abacus_3 from "../assets/projects/abacus/3.jpg";
import abacus_4 from "../assets/projects/abacus/4.jpg";
import abacus_5 from "../assets/projects/abacus/5.jpg";
import abacus_6 from "../assets/projects/abacus/6.jpg";
import abacus_7 from "../assets/projects/abacus/7.jpg";
import abacus_8 from "../assets/projects/abacus/8.jpg";
import abacus_9 from "../assets/projects/abacus/9.jpg";
import abacus_10 from "../assets/projects/abacus/10.jpg";
import abacus_11 from "../assets/projects/abacus/11.jpg";
import abacus_12 from "../assets/projects/abacus/12.jpg";

export const venuImages = [venu, venu_1, venu_2, venu_3, venu_4, venu_5];

export const abacusImages = [
  abacus_1,
  abacus_2,
  abacus_3,
  abacus_4,
  abacus_5,
  abacus_6,
  abacus_7,
  abacus_8,
  abacus_9,
  abacus_10,
  abacus_11,
  abacus_12,
];
export const alesayiImages = [
  alesayi_1,
  alesayi_2,
  alesayi_3,
  alesayi_4,
  alesayi_5,
  alesayi_6,
  alesayi_7,
];
export const limeLiteImages = [
  limelite_1, // opertinitis
  limelite_16,
  limelite_3,
  limelite_2,
  limelite_4,
  limelite_5,
  limelite_7,
  limelite_8,
  limelite_17, // media
  limelite_18,
  limelite_19,
  limelite_15,
  limelite_9, // chat
  limelite_12,
  limelite_10,
  limelite_11,
  limelite_23, // profile
  limelite_20,
  limelite_21,
  limelite_22,
];

export const shopImages = [
  herpShop,
  shop_1,
  shop_2,
  shop_3,
  shop_4,
  shop_5,
  shop_6,
  shop_7,
  shop_8,
  shop_9,
];

export const nextorImages = [nextor, nextor_1, nextor_2, nextor_3, nextor_4];

export const uiLibImages = [ui, ui_1, ui_2, ui_3, ui_4, ui_5];

export const neatourImages = [
  neatour,
  neatour_1,
  neatour_2,
  neatour_3,
  neatour_4,
  neatour_5,
];

export const beheroImages = [behero, behero_1, behero_2, behero_3];

export const palAgencyImages = [
  palAgency,
  palAgency_1,
  palAgency_2,
  palAgency_3,
  palAgency_4,
  palAgency_5,
];

export const projectsImages = [
  limeLiteImages,
  abacusImages,
  alesayiImages,
  shopImages,
  palAgencyImages,
  venuImages,
  beheroImages,
  uiLibImages,
  neatourImages,
  nextorImages,
];
